export default class ServiceCards {
  constructor() {
    this.getDomElements()

    if (!this.dom.cards.length) return
    
    this.init()
  }

  init() {
    this.dom.cards.forEach(card => {
      card.addEventListener('click', () => {
        if (card.classList.contains('is-active')) return

        const currentActive = document.querySelector('.js-service-cards.is-active')

        currentActive.classList.remove('is-active')
        card.classList.add('is-active')
      })
    })
  }

  getDomElements() {
    this.dom = {
      'cards' : document.querySelectorAll('.js-service-cards')
    }
  }
}